export default __webpack_public_path__ + "static/media/no-salt.b73b0e05.png";